import { render, staticRenderFns } from "./StarsWithCount.vue?vue&type=template&id=dbe1b9a6&scoped=true&"
import script from "./StarsWithCount.vue?vue&type=script&lang=js&"
export * from "./StarsWithCount.vue?vue&type=script&lang=js&"
import style0 from "./StarsWithCount.vue?vue&type=style&index=0&id=dbe1b9a6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dbe1b9a6",
  null
  
)

export default component.exports